"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOBILE_LAYOUT = exports.TABLET_LAYOUT = exports.DESKTOP_LAYOUT = exports.getLayoutType = void 0;
var DESKTOP_LAYOUT = 'desktop';
exports.DESKTOP_LAYOUT = DESKTOP_LAYOUT;
var TABLET_LAYOUT = 'tablet';
exports.TABLET_LAYOUT = TABLET_LAYOUT;
var MOBILE_LAYOUT = 'mobile';
exports.MOBILE_LAYOUT = MOBILE_LAYOUT;

var getLayoutType = function getLayoutType() {
  if (window.matchMedia('(max-width: 767px)').matches) {
    return MOBILE_LAYOUT;
  }

  if (window.matchMedia('(max-width: 1199px)').matches) {
    return TABLET_LAYOUT;
  }

  return DESKTOP_LAYOUT;
};

exports.getLayoutType = getLayoutType;